import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={24}
    viewBox="0 0 26 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M23.072 3A3 3 0 0 1 26 6v13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6a3 3 0 0 1 2.928-3h20.144ZM2 6.273V19a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6.273l-8.297 7.606a4 4 0 0 1-5.406 0L2 6.273ZM22.43 5H3.57l8.079 7.405a2 2 0 0 0 2.702 0L22.43 5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
